import React from 'react';
import { MDBContainer, } from "mdb-react-ui-kit";
import "../css/servicesfont.css";
const Smartreportinfo = () => {
    return (
        <MDBContainer fluid className="p-0">
            <div className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{ fontFamily: 'Lora, serif' }}> Practice Analytics </h1>
                            <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500',textAlign: 'justify' }}>  
                                At <b>AcerHealth,</b> you can integrate any practice management system or medical billing services platform with our <b>Smart Reports </b>to generate helpful,
                                 easy-to-use reports without sifting through endless pages of data. Our Smart Reports provide a thorough, holistic analysis of your practice’s 
                                 financial and operational health, supporting smarter decisions that enhance revenue cycle management, medical billing outsourcing, and denial
                                  rate reduction efforts. With an intuitive interface, engaging dashboards, and graphical assortments, you can specify parameters to create
                                   reports and monitor key indicators such as operational costs, billing and reimbursement cycles, accounts receivable, and revenue streams. 
                                   This insight helps you identify underperforming areas and operational silos to
                                   
 <a
                            href="https://acerhealth.com/blog/revenue-cycle-management-tips"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              improve productivity and maximize revenue.
                        </a>   In addition to 
                                   standard tabular reports, you also gain access to automated tools like real-time accounts receivable tracking, customizable dashboards for
                                    EMR billing integration and telehealth billing solutions, and alerts that support healthcare denial management and medical billing compliance
                                     services, ensuring your practice stays efficient, compliant, and financially strong.   </p>
                        </div>
                    </div>
                </div>
            </div>
        </MDBContainer>
    );
};
export default Smartreportinfo;